import { render, staticRenderFns } from "./ArticleInfoSummary.vue?vue&type=template&id=7aef0132&scoped=true"
import script from "./ArticleInfoSummary.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoSummary.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoSummary.vue?vue&type=style&index=0&id=7aef0132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef0132",
  null
  
)

export default component.exports